import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-590213066__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Dialog", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-590213066__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M174 58.04H66.03c-1.1 0-2 .9-2 2l-.04 83.17c0 .73.37 1.2.59 1.42s.69.59 1.41.59l54.02-.04c1.06 0 2.08.42 2.83 1.17l17.96 17.98v-15.11c0-2.21 1.79-4 4-4h29.19c1.1 0 2-.9 2-2.01V60.04c0-1.11-.9-2.01-2-2.01ZM78 73.17h66.02v8H78zm78.02 56.04H78v-8h78.02zm5.97-24.02H78v-8h83.99z",
      style: {"fill":"none"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M78 73.17h66.02v8H78zM78 97.19h83.99v8H78zM78 121.2h78.02v8H78z",
      class: "i-590213066__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M184 60.04c0-5.52-4.49-10.01-10-10.01H66.03c-5.51 0-10 4.49-10 10l-.04 83.17c0 2.67 1.04 5.19 2.93 7.08a9.93 9.93 0 0 0 7.07 2.93l52.36-.04 23.62 23.64a4 4 0 0 0 2.83 1.17c.51 0 1.03-.1 1.53-.3 1.5-.62 2.47-2.08 2.47-3.7V153.2h25.19c5.52 0 10-4.49 10-10.01V60.04Zm-8 83.18c0 1.11-.9 2.01-2 2.01h-29.19c-2.21 0-4 1.79-4 4v15.11l-17.96-17.98a4 4 0 0 0-2.83-1.17l-54.02.04c-.72 0-1.19-.37-1.41-.59s-.59-.7-.59-1.42l.04-83.17c0-1.1.9-2 2-2h107.97c1.1 0 2 .9 2 2.01v83.18Z",
      class: "i-590213066__cls-2"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("path", {
      d: "M8 24.01v83.17c0 5.52 4.49 10.01 10 10.01h4.58v20.78c0 1.62.97 3.08 2.47 3.7a4.014 4.014 0 0 0 4.36-.87L47 123.19l-5.66-5.65-10.76 10.77V113.2c0-2.21-1.79-4-4-4H18c-1.1 0-2-.9-2-2.01V24.01c0-1.11.9-2.01 2-2.01h107.98c1.1 0 2 .9 2 2l.02 14.24h8l-.02-14.25c-.01-5.5-4.5-9.98-10-9.98H18c-5.52 0-10 4.49-10 10.01Z",
      class: "i-590213066__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "dialoge"}) } }